import React, { useState } from 'react';
import { Box, Typography, IconButton, Button, CircularProgress } from '@mui/material';
import moment from 'moment';
import DeleteIcon from "../../../../../../../styles/svg/delete.svg";
import { deleteHPDTicketNote } from '../../../../../../../sevices/violationsApi';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { isAdmin } from '../../../../../../../utils/helpers';


const NoteItem = ({ note, refetch }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { mutate: deleteHPDTicketNoteMutation, isPending } = useMutation({
    mutationFn: deleteHPDTicketNote,
    onSuccess: () => {
      toast.success("Note deleted successfully");
      setIsEditing(false);
      refetch();
    },
    onError: () => {
      toast.error("Failed to delete note");
    },
  });

  const handleDelete = () => {
    deleteHPDTicketNoteMutation(note.note_id);
  };

  const handleCancel = () => {
    if (!isPending) {
      setIsEditing(false);
    }
  };

  return (
    <Box className="note-item">
      <Box className="note-date-badge">
        {moment(note.date).format('MM/DD/YYYY')}
      </Box>
      <Box className="note-content">
        <Typography variant="body1">
          {note?.content}
        </Typography>
        {isEditing ? (
          <Box className="note-edit-actions">
            <Button 
              size="small" 
              color="primary" 
              onClick={handleCancel}
              disabled={isPending}
              className="note-edit-cancel-btn"
            >
              Cancel
            </Button>
            <Button 
              size="small" 
              color="primary" 
              onClick={handleDelete}
              disabled={isPending}
              startIcon={isPending && <CircularProgress size={16} color="inherit" />}
              className="note-edit-confirm-btn"
            >
              {isPending ? "Deleting..." : "Confirm"}
            </Button>
          </Box>
        ) : (
          isAdmin() && <IconButton 
            size="small" 
            className="delete-note"
            onClick={() => setIsEditing(true)}
          >
            <img src={DeleteIcon} alt="delete" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default NoteItem; 